import React from "react";
import { Permissioned } from "react-permissions";
import { connect } from "react-redux";
import Divider from "../../common/divider";
import PageTitle from "../../common/pageTitle";
import DiscoverApi from "../../../api/DiscoverApi";
import Util from "../../../util/util";
import Messages from "../../../configurations/messages";
import Permissions from "../../../configurations/permissions";
import Breadcrumbs from "react-breadcrumbs";
import Toaster from "toastr";
import Constants from "../../../configurations/constants";
import DiscoverCaseSearch from "./DiscoverCaseSearch";
import DiscoverCaseTable from "./DiscoverCaseTable";
import DiscoverCaseDetailsModal from "./DiscoverCaseDetailsModal";

class DiscovercasePage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tableData: [],
      selectedDispute: null,
      documents: null,
      fetchingDocuments: false,
      loading: false,
      pageNum: 0,
      pageSize: Constants.DEFAULT_TABLE_PAGE_SIZE,
      pages: 0,
      filterParams: null
    };
    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onDisputeRowClick = this.onDisputeRowClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.paginateid = this.paginateid.bind(this);
    this.onTableChange = this.onTableChange.bind(this);
    this.getCaseDetails = this.getCaseDetails.bind(this);
    this.getCaseDocuments = this.getCaseDocuments.bind(this);
  }

  paginateid(index) {
    const offset = parseInt(this.state.pageNum, 0);
    const pagesize = parseInt(this.state.pageSize, 0);
    const result =
      offset * pagesize + index + Constants.PAGINATION_OFFSET_INDEX;
    return result.toString();
  }

  componentDidMount() {
    //Load data on mount
    this.onSearchHandler({ pageSize: this.state.pageSize });
  }

  onSearchHandler(params, resetPageNumber) {
    //Reset states
    let stateUpdate = { loading: true, tableData: [] };
    if (resetPageNumber) {
      stateUpdate.pageNum = 0;
      params.pageNum = 1;
    }
    this.setState(stateUpdate);
    params.pageSize = params.pageSize || this.state.pageSize;
    params.pageNum = params.pageNum || this.state.pageNum + 1;

    DiscoverApi.getDiscovercases(params)
      .then(response => {
        let data = response.data && response.data.content;
        data = data.map(d => {
          return {
            ...d,
            createdOn: Util.toUserLocalTime(d.createdOn)
          };
        });
        let totalCount = response.data && response.data.count;
        let pages = totalCount
          ? Math.ceil(
              totalCount /
                (params.pageSize || Constants.DEFAULT_TABLE_PAGE_SIZE)
            )
          : 0;
        if (data.length === 0)
          Toaster.warning("No records found.", "Discover Cases");

        this.setState({
          tableData: data,
          loading: false,
          filterParams: params,
          totalCount: totalCount,
          pages: pages
        });
      })
      .catch(error => {
        console.log(error);
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CASES_SEARCH}`
        ]);
        this.setState({ loading: false });
      });
  }

  onTableChange(state, instance) {
    let pageSize = instance.state.pageSize;
    let pageNum = instance.state.page; //table page  - Zero based index
    this.setState({ pageSize: pageSize, pageNum: pageNum });
    if (this.state.filterParams) {
      let params = Util.clone(this.state.filterParams);
      params.pageSize = pageSize;
      params.pageNum = pageNum + 1;

      this.onSearchHandler(params);
    }
  }

  getCaseDetails(caseNumber) {
    this.setState({ loading: true });
    DiscoverApi.getDiscoverCase(caseNumber)
      .then(response => {
        let data = response.data;
        data = {
          ...data,
          createdOn: Util.toUserLocalTime(data.createdOn)
        };
        this.setState({ selectedDispute: data, loading: false });
      })
      .catch(error => {
        Util.errorMessageToast(Toaster, error.data, [
          `${Messages.ERROR_CASES}`
        ]);
        this.setState({ loading: false });
      });
  }

  getCaseDocuments(caseNumber) {
    this.setState({ fetchingDocuments: true });
    DiscoverApi.getCaseDocuments(caseNumber)
      .then(response => {
        let data = response.data;
        data = data.map(doc => ({
          ...doc,
          receivedOn: Util.toUserLocalTime(doc.receivedOn)
        }));
        this.setState({ documents: data, fetchingDocuments: false });
      })
      .catch(error => {
        Toaster.error(Messages.ERROR_CASE_DOCUMENTS);
        this.setState({ fetchingDocuments: false });
      });
  }

  onDisputeRowClick(index) {
    this.setState({ loading: true });
    const selectedDispute = this.state.tableData[index];
    this.getCaseDetails(selectedDispute.caseNumber);
  }

  handleCloseModal(reloadDataFlag) {
    this.setState({ selectedDispute: null });
    if (reloadDataFlag) {
      this.onSearchHandler(this.state.filterParams);
    }
  }

  render() {
    const { documents, fetchingDocuments } = this.state;
    return (
      <div>
        <div id="page-breadcrumb" className="breadcrumb-container">
          <Breadcrumbs
            separator={Constants.BREADCRUMB_SEPARATOR}
            routes={this.props.routes}
            params={this.props.params}
          />
        </div>
        <PageTitle title="Discover Cases" />
        <DiscoverCaseSearch onSearchHandler={this.onSearchHandler} />
        <Divider />
        <DiscoverCaseTable
          onRowClick={this.onDisputeRowClick}
          tableData={this.state.tableData}
          loading={this.state.loading}
          onTableChange={this.onTableChange}
          page={this.state.pageNum}
          pages={this.state.pages}
          defaultPageSize={Constants.DEFAULT_TABLE_PAGE_SIZE}
          paginatedCallBack={this.paginateid}
        />
        {this.state.selectedDispute && (
          <DiscoverCaseDetailsModal
            onRequestClose={this.handleCloseModal}
            getCaseDocuments={this.getCaseDocuments}
            documents={documents}
            fetchingDocuments={fetchingDocuments}
            getCaseDetail={this.getCaseDetails}
            isOpen={this.state.selectedDispute != null}
            caseDetails={this.state.selectedDispute}
          />
        )}
      </div>
    );
  }
}

export default connect(Util.defaultMapStateToProps)(
  Permissioned(DiscovercasePage, [Permissions.CREATE_DISPUTE])
);



// WEBPACK FOOTER //
// ./src/components/discover/cases/DiscoverCasePage.js